//#region src/combo_upsell_type.ts
var ComboUpsellType = /* @__PURE__ */ function(ComboUpsellType) {
	ComboUpsellType["MenuItem"] = "menu-item";
	ComboUpsellType["ComboBuilderModGroup"] = "combo-builder-mod-group";
	return ComboUpsellType;
}(ComboUpsellType || {});
//#endregion
export { ComboUpsellType };

//# sourceMappingURL=combo_upsell_type.js.map